export const FORMS_STORE_KEY = 'forms';
